import React from "react";
import Logo from "../../Assets/svg/mawaloglogo1.svg";
const PoweredBy = ({ paddingTop = "10px", paddingBottom = "10px" }) => {
  const websiteUrl = process.env.REACT_APP_WEBSITE_URL;
  return (
    <div
      style={{
        textAlign: "center",
        paddingTop,
        paddingBottom,
        fontWeight: "400",
        fontSize: "12px",
        color: "#172B4D",
        backgroundColor: "#F5F6FA",
      }}
    >
      Powered by{" "}
      <span>
        <img
          src={Logo}
          alt="Mawa Logo"
          style={{ height: "16px", verticalAlign: "middle", cursor: "pointer" }}
          onClick={() => {
            window.open(websiteUrl, "_blank", "noopener,noreferrer");
          }}
        />
      </span>
    </div>
  );
};

export default PoweredBy;
